const ContactSection = () => {
  return (
    <div className="space-y-2 mt-6">
      <h3 className="text-lg font-semibold">Got questions?</h3>
      <div className="flex flex-col items-center gap-1">
        <a 
          href="https://api.whatsapp.com/message/WQDLXQXXB3ICH1?autoload=1&app_absent=0" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-2 hover:opacity-80 transition-opacity"
        >
          <span>Drop us a WhatsApp</span>
          <img 
            src="/images/whatsapp-business-logo.png" 
            alt="WhatsApp Business"
            className="h-12 w-12 object-contain"
          />
        </a>
        <p className="text-sm text-muted-foreground mt-1">or email</p>
        <a href="mailto:hey@niumora.com" className="text-primary hover:underline">
          hey@niumora.com
        </a>
      </div>
    </div>
  );
};

export default ContactSection;
